import { render, staticRenderFns } from "./CreateContainerWizard.vue?vue&type=template&id=0d97870a&scoped=true"
import script from "./CreateContainerWizard.vue?vue&type=script&lang=js"
export * from "./CreateContainerWizard.vue?vue&type=script&lang=js"
import style0 from "./CreateContainerWizard.vue?vue&type=style&index=0&id=0d97870a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97870a",
  null
  
)

export default component.exports